/**
 * 결제 내역 페이지 — 별도 라우트 진입용.
 *  크레딧의 "결제 내역" 탭과 같은 콘텐츠를 LayoutHeader 와 함께 표시.
 *  URL 직접 진입 / 외부 링크용으로 유지.
 */
import { createFileRoute } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import { PaymentHistoryContent } from "@/business/credit/PaymentHistoryContent";

export const Route = createFileRoute("/business/layout/user-payment-history")({
  component: PaymentHistory,
});

function PaymentHistory() {
  return (
    <>
      <LayoutHeader title="결제 내역" hasBackBtn hasFootPrint={false} />
      <div className="flex-1 min-h-0 overflow-y-auto bg-[#F5F5F5]">
        <PaymentHistoryContent />
      </div>
    </>
  );
}
